import type { LatLong } from '@iheartjane/geolocation';
import type { Address } from '@iheartjane/types';

import { distance } from './location';

export const calculateDistance = (
  userCoordinates: LatLong | undefined,
  storeCoordinates: LatLong
) => {
  if (!userCoordinates) return 0;
  return parseFloat(distance(userCoordinates, storeCoordinates));
};

export const deliveryCoordinates = (
  deliveryAddress: Address | null
): LatLong | undefined =>
  deliveryAddress && deliveryAddress.lat && deliveryAddress.lng
    ? {
        lat: deliveryAddress.lat,
        long: deliveryAddress.lng,
      }
    : undefined;
